module.exports = __webpack_public_path__ + "static/article-8e7c58a420bf52e2c9ad3ba24489e877.png";